export const defaultPronounceOptions = [
  {
    label: "He/Him",
    value: "He/Him",
  },
  {
    label: "She/Her",
    value: "She/Her",
  },
  {
    label: "They/Them",
    value: "They/Them",
  },
]

export const defaultGenderOptions = [
  {
    label: "Male",
    value: "Male"
  },
  {
    label: "Female",
    value: "Female",
  },
  {
    label: "Other",
    value: "Other",
  },
];

export const defaultTitleOptions = [
  {
    label: "Mr.",
    value: "Mr.",
  },
  {
    label: "Miss",
    value: "Miss",
  },
  {
    label: "Mrs.",
    value: "Mrs.",
  },
  {
    label: "Ms.",
    value: "Ms.",
  },
  {
    label: "Dr.",
    value: "Dr.",
  },
  {
    label: "other",
    value: "other",
  },
];

export const defaultStatusOptions = [
  {
    label: "Single",
    value: "Single",
  },
  {
    label: "Married",
    value: "Married",
  },
  {
    label: "Life Partner",
    value: "Life Partner",
  },
];

export const defaultReligionOptions = [
  {
    label: "Jewish",
    value: "Jewish",
  },
  {
    label: "Converting",
    value: "Converting",
  },
  {
    label: "Other",
    value: "Other",
  },
];

export const defaultRelationshipOptions = [
  { value: "Parent-1", label: "Parent-1" },
  { value: "Parent-2", label: "Parent-2" },
  { value: "Parent-3", label: "Parent-3" },
  { value: "Adult-1", label: "Adult-1" },
  { value: "Adult-2", label: "Adult-2" },
  { value: "Adult-3", label: "Adult-3" },
  { value: "Child", label: "Child" },
  { value: "Father", label: "Father" },
  { value: "Mother", label: "Mother" },
  { value: "Brother", label: "Brother" },
  { value: "Sister", label: "Sister" },
  { value: "Wife", label: "Wife" },
  { value: "Husband", label: "Husband" },
  { value: "Father-in-law", label: "Father-in-law" },
  { value: "Mother-in-law", label: "Mother-in-law" },
  { value: "Brother-in-law", label: "Brother-in-law" },
  { value: "Sister-in-law", label: "Sister-in-law" },
  { value: "Uncle", label: "Uncle" },
  { value: "Aunt", label: "Aunt" },
  { value: "Nephew", label: "Nephew" },
  { value: "Niece", label: "Niece" },
  { value: "Grandmother", label: "Grandmother" },
  { value: "Grandfather", label: "Grandfather" },
  { value: "Great-grandmother", label: "Great-grandmother" },
  { value: "Great-grandfather", label: "Great-grandfather" },
  { value: "Cousin", label: "Cousin" },
  { value: "Friend", label: "Friend" },
  { value: "Grandson", label: "Grandson" },
  { value: "Granddaughter", label: "Granddaughter" },
  { value: "Son-in-Law", label: "Son-in-Law" },
  { value: "Daughter-in-Law", label: "Daughter-in-Law" },
  { value: "Other", label: "Other" }
]